import { map } from 'lodash';
import { Acknowledgement, AcknowledgementForSingleCve } from 'types';
import { getAckTextListFromAckList } from './getAckTextListFromAckList';

//NOTE: This is kind of a mess and should be redone when we do the @tanstack/react-query migration
/**
 * Merges acks, groups together the researchers who collaborated on the same CVE
 *
 * @param arr an array of individual ack objects
 * @returns single ack object, with all the contributors grouped into a single row
 */
export const mergeAcknowledgementGroup = (
  arr: Acknowledgement[]
): AcknowledgementForSingleCve => ({
  ...arr?.[0],
  ackText: getAckTextListFromAckList(arr),
  id: map(arr, a => a.id),
});
